export const errorUnsupportedPlayerType = new Error('Unsupported player type');
export const errorPlayerContainerNotCreated = new Error('Player container not created');
export const errorPlayerNotCreated = new Error('Player not created');
export const errorPlayerZapiNotCreated = new Error('Player zapi not created');
